// logic
// components

import { useHistory } from 'react-router-dom';
import quoteFormSchema from '../quoteForm/config/quoteFormSchema';
import useTicketDetail from '../ticketDetail/useTicketDetail';
import quoteService from 'modules/emergencies/quoteService';
import { mutate } from 'swr';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const useNewQuote = ({ id }) => {
  const history = useHistory();

  const { isLoadingTicketDetail, ticketDetail, ticketDetailError } = useTicketDetail({ id });

  const validationSchema = quoteFormSchema;

  let initialValues = quoteService.defaultValues.getDefaultInitialFormValues();
  if (!!ticketDetail)
    initialValues = quoteService.dataTransformation.getInitialNewQuoteFormValuesFromTicketDetail({
      ticketDto: ticketDetail,
    });

  const isReadOnly = false;
  const isEdit = false;

  const isQuoteCostActive = useSelector((store) =>
    getSpecificClientConfig(store, constants.EMERGENCIES_CARRIER_SELECTOR)
  );
  const onSubmit = async ({ values }) => {
    const quoteDto = quoteService.dataTransformation.getQuoteDtoFromFormValuesAndTicket({
      values,
      ticketDto: ticketDetail,
      isQuoteCostActive,
    });
    await quoteService.callBackend.crateNewQuote({ quoteDto, ticketId: id });
    // we are mutating the tickets cache so it will reload automatically
    mutate((key) => {
      return typeof key === 'string' && key.startsWith('tickets');
    });
    history.push('/emergencies');
  };

  const onCancel = () => {
    history.push('/emergencies');
  };

  return {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isLoadingTicketDetail,
    ticketDetail,
    ticketDetailError,
  };
};

export default useNewQuote;
